import React, { useEffect, useState } from "react";
import STC from "../../STCFactory/STCFactory";
import { LookUpAPIs } from "../../../API/LookUpAPIs/LookUpAPIs";

function CountryDropDown(props) {
    const [loading, setLoading] = useState(true);
    const [countryData, setCountryData] = useState([]);

    const sortArray = (array) => {

    }

    useEffect(() => {
        const getCountryData = async () => {
            try {
                const response = await LookUpAPIs.GetCountries();
                if (response.status === 200) {
                    const temp = [...response.data]
                    temp.sort((a, b) => {
                        if (a['name'] < b['name']) {
                            return -1;
                        }
                        if (a['name'] > b['name']) {
                            return  1;
                        }
                        return 0;
                    });
                    setCountryData(temp);
                    if (props.setAllCountryData) {
                        props.setAllCountryData(response.data);
                    }
                } else {
                    console.error("API Error:", response.status);
                }
            } catch (err) {
                console.error("ERROR:", err.message);
            } finally {
                setLoading(false); 
            }
        };

        getCountryData();
    }, []); 

    return (
        <STC.Form.Select
            disabled={props.disabled}
            className={props.className}
            value={props.value}
            required={props.required}
            onChange={props.onChange}
            size={props.size}
        >
            <option disabled value="">
                {loading ? "Loading..." : "Select a Country"}
            </option>
            {countryData.length > 0 && <option value={'IE'}>Ireland</option>}
            {countryData.length > 0 && <option value={'GB'}>United Kingdom</option>}
            {countryData.length > 0 ? (
                countryData.map((data, index) => (
                    <option key={index} value={data.code}>
                        {data.name}
                    </option>
                ))
            ) : (
                !loading && <option disabled>No Countries Available</option>
            )}
        </STC.Form.Select>
    );
}

export default CountryDropDown;
